import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AdminLayout from "layouts/Admin";
import { BASE_URL } from "utils/constants";
import { setPermissions } from "./store/actions/auth.actions";
import Socket, { initConeection } from "./components/Socket/Socket"
import { setTokenExpiration } from './utils/auth-refresh'
import { useRef } from "react";
axios.defaults.withCredentials = true;
if (window.location !== window.parent.location) {
  axios.defaults.headers.common["iframe"] = true;
}

const App = () => {
  const dispatch = useDispatch();
  const [isAuth, setIsAuth] = useState(false);
  const permissions = useSelector((state) => state.permissions);
  const mySwal = withReactContent(Swal);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const token = Cookies.get("studentportaltoken");
      let decodedToken = {};

      try {
        if (token) {
          localStorage.setItem("token",token);
          setIsAuth(true);
          // initConeection( SOCKET_URL , token );
          decodedToken = jwt_decode(token || "");
          setTokenExpiration(decodedToken)
          let res = null;
          if (window.location !== window.parent.location) {
            // axios.defaults.headers.common['iframe'] = true;
            res = await axios.post(`${BASE_URL}/auth/login.php`, {
              username: decodedToken.data.user.ivyemail,
            });

          } else {
            res = await axios.post(`${BASE_URL}/auth/updateroles.php`, {
              username: decodedToken.data.user.ivyemail,
            });
          }

          // const authAxios = axios.create({
          //   baseURL : BASE_URL,
          //   headers : {
          //     iframe : true
          //   }
          // })

          if (res.data.data != null) {
            localStorage.setItem("token",res.data.data);
            decodedToken = jwt_decode(res.data.data || "");
            setTokenExpiration(decodedToken)

            dispatch(setPermissions({ ...decodedToken.data.user }));
          } else {
            RedirectToLogin();
          }
          return;
        }

        axios
          .post(`${BASE_URL}/auth/login.php`)
          .then((response) => {

            if (response.data.data) {
              setIsAuth(true);
              const token = response.data.data;
              // initConeection( SOCKET_URL , token );
              Cookies.set("studentportaltoken", token);
              localStorage.setItem("token",token);
              decodedToken = jwt_decode(token);
              setTokenExpiration(decodedToken)

              dispatch(setPermissions({ ...decodedToken.data.user }));
              setIsAuth(true);

            } else {
              RedirectToLogin();
            }
          })
          .catch((error) => {

            RedirectToLogin();
          });
      } catch {
        Swal.fire("Something went wrong!", "", "error");
      }
    })();
  }, []);

  // alert when student has quizzes

  useEffect(async () => {

    let res = await axios.get(`${BASE_URL}/exam/getstudentexams.php`);

    if (res.data.data.exams.length > 50) {
      mySwal.fire({
        html: (
          <>
            <ul className="fs-6 fw-bold w-100 mb-5">
              {res.data.data.exams.length > 0 &&
                res.data.data.exams.map((exam, key) => {
                  return (
                    <li key={key}>
                      {/* {`${examLink}${exam.id}`} */}
                      <a href={exam.examlink} target="_blank">
                        Go To {exam.coursename} Quizz --&gt;&gt;{" "}
                        {exam.examname}
                      </a>
                    </li>
                  );
                })}
            </ul>
          </>
        ),
        title: "You have to finish quizzes",
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      //clearInterval(periodicCheck)
    } else if (res.data.data.surveys.length > 50) {
      mySwal.fire({
        html: (
          <>
            <ul className="fs-6 fw-bold w-100 mb-5">
              {res.data.data.surveys.length > 0 &&
                res.data.data.surveys.map((survey, key) => {
                  return (
                    <li key={key}>
                      {/* {`${examLink}${exam.id}`} */}
                      <a href={survey.link} target="_blank">
                        Go To {survey.subject}
                      </a>
                    </li>
                  );
                })}
            </ul>
          </>
        ),
        title: "You have to finish quizzes",
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      //clearInterval(periodicCheck)
    } else {
    }

  }, []);

  // ------------------------------

  const RedirectToLogin = () => {
    window.location.replace(`${BASE_URL}/login.php`);
  };
  const mytopEle = useRef(null)

  function scrollToTop() {
    if (mytopEle.current !== null) {
      mytopEle.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <div className="App" id="wrapper">
      <div id="topelement" />
      <Router>
        <Socket />
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return isAuth == true && <Redirect to="/home" />;
            }}

          />
          <AdminLayout />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
